import { render, staticRenderFns } from "./Res1.vue?vue&type=template&id=57366204&scoped=true&lang=pug"
import script from "./Res1.vue?vue&type=script&lang=js"
export * from "./Res1.vue?vue&type=script&lang=js"
import style0 from "./Res1.vue?vue&type=style&index=0&id=57366204&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57366204",
  null
  
)

export default component.exports